import React from 'react';
import SalesChart from './SalesChart';
import RankingTable from './RankingTable';
import SubscriptionOverlay from './SubscriptionOverlay';
import { CHART_COLORS } from '../constants';
import { formatCurrency, getMonthDisplay } from '../helpers';
import styles from '../summary.module.scss';

const ClientesSection = ({ salesData, sortedClients, isPremium }) => {
  return (
    <div className={styles.reportGate}>
      <div className={`${styles.reportContent} ${!isPremium ? styles.blurred : ''}`}>
        {/* Metricas */}
        <div className={styles.reportMetrics}>
          <div className={styles.reportMetricCard}>
            <span className={styles.reportMetricLabel}>Total Ventas</span>
            <span className={styles.reportMetricValue}>
              {salesData ? formatCurrency(salesData.total) : '$0.00'}
            </span>
          </div>
          <div className={styles.reportMetricCard}>
            <span className={styles.reportMetricLabel}>Clientes Activos</span>
            <span className={styles.reportMetricValue}>
              {salesData?.clients?.length || 0}
            </span>
          </div>
          <div className={styles.reportMetricCard}>
            <span className={styles.reportMetricLabel}>Promedio / Cliente</span>
            <span className={styles.reportMetricValue}>
              {formatCurrency(
                salesData?.clients?.length
                  ? salesData.total / salesData.clients.length
                  : 0,
              )}
            </span>
          </div>
        </div>

        {/* Grafico + Leyenda */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
              <h2 className={styles.cardTitle}>Distribución de Ventas</h2>
              <span className={styles.cardCount}>
                {getMonthDisplay(salesData?.month)}
              </span>
            </div>
          </div>
          <div className={styles.chartLayout}>
            <div className={styles.chartPane}>
              <SalesChart data={sortedClients} height={380} />
            </div>
            <div className={styles.legendPane}>
              <h3 className={styles.legendHeading}>Clientes</h3>
              <div className={styles.legendItems}>
                {sortedClients.map((client, i) => (
                  <div key={client.name} className={styles.legendRow}>
                    <span
                      className={styles.legendDot}
                      style={{
                        backgroundColor: CHART_COLORS[i % CHART_COLORS.length],
                      }}
                    />
                    <span className={styles.legendName}>{client.name}</span>
                    <span className={styles.legendVal}>
                      {formatCurrency(client.total)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Tabla de ranking */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
              <h2 className={styles.cardTitle}>Ranking de Clientes</h2>
              <span className={styles.cardCount}>
                Ordenados por valor — {getMonthDisplay(salesData?.month)}
              </span>
            </div>
          </div>
          <RankingTable data={sortedClients} entityLabel="Cliente" />
        </div>
      </div>

      {!isPremium && <SubscriptionOverlay />}
    </div>
  );
};

export default ClientesSection;
